"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueFromInstance = function (key, encodedInstance) {
    var decodeFunc;
    if (isBrowser()) {
        decodeFunc = (window.atob);
    }
    else {
        decodeFunc = nodeDecoder;
    }
    var echoedData = encodedInstance.split('.').pop();
    var decodedData = decodeFunc(echoedData);
    var instanceObject = JSON.parse(decodedData);
    return instanceObject[key];
};
var isBrowser = new Function('try {return this===window;}catch(e){ return false;}');
function nodeDecoder(encodedData) {
    return Buffer.from(encodedData, 'base64').toString();
}
//# sourceMappingURL=wix-Instance-value.js.map